// Import components
import './quick-actions';
import './run-now-button/index.ts';
import './status-toggle';

// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-footer' )
export class AutomatorBuilderPublishFooter extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<div class="footer">
				<div class="footer-quick-actions">
					<uap-builder-publish-quick-actions></uap-builder-publish-quick-actions>
				</div>
				<div 
					class="footer-cta"
					?recipe-on=${ UncannyAutomator._recipe.is_recipe_on }
					?has-run-now=${ UncannyAutomator._recipe.miscellaneous.has_run_now }
				>
					<uap-builder-publish-status-toggle></uap-builder-publish-status-toggle>
					<uap-builder-publish-run-now-button></uap-builder-publish-run-now-button>
				</div>
			</div>
		`;
	}
}